import { useState, useEffect } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form'
import {
  FormDropDownList,
  FormDropDownListFilter,
  FormTextArea,
  FormDatePicker,
} from '../FormComponents'
import { getSitesDropdown, getMatchingClientSite, getTargetSite } from '../../../data/siteData'
import { getClientsDropdown } from '../../../data/clientData'
import { getEnquirysourceDropdown } from '../../../data/enquirysourceData'
import { getEmployeeDropdown } from '../../../data/employeeData'
import { dropDown } from '../../../data/interfaces'
import { requiredValidator } from '../Validators'
import { FormInput } from '../FormComponents'
import { useToast } from '../../../contexts/ToastContext'
import { getAddressesForClientDropdown, getClientsForClientsDropdown, getClientByIdV2 } from '../../../data/accountsData'
import { FaFlag, FaTable } from 'react-icons/fa'

const AddEnquiryForm = (props: any) => {
  const [freehand, setFreehand] = useState(false)
  const [siteData, setSiteData] = useState<dropDown[]>([])
  const [siteDataOrig, setSiteDataOrig] = useState<dropDown[]>([])
  const [clientData, setClientData] = useState<dropDown[]>([])
  const [clientDataOrig, setClientDataOrig] = useState<dropDown[]>([])
  const [enquirysourceData, setEnquirysourceData] = useState<dropDown[]>([])
  const [employeeData, setEmployeeData] = useState<dropDown[]>([])
  const [employeeDataOrig, setEmployeeDataOrig] = useState<dropDown[]>([])
  const [matchSiteActive, setMatchSiteActive] = useState(false)
  const [isBadDebter, setIsBadDebter] = useState(false)

  const { showToast } = useToast()

  const [formState, setFormState] = useState<any>({
    contactId: 0,
    clientName: '',
    client: {
      value: 0,
      text: '',
    },
    siteAddr: {
      value: 0,
      text: '',
    },
    enquirysourceId: {
      value: 0,
      text: '',
    },
    dueDate: '',
    description: '',
    employeeAssignedToId: {
      value: 0,
      text: '',
    },
  })

  useEffect(() => {
    const fetchSiteData = async () => {
      const siteData = await getSitesDropdown('')
      setSiteData(siteData)
      setSiteDataOrig(siteData)
    }

    const fetchClientData = async () => {
      const clientData = await getClientsDropdown('')
      setClientData(clientData)
      setClientDataOrig(clientData)
    }

    const fetchEnquirysourceData = async () => {
      const enquirysourceData = await getEnquirysourceDropdown()
      setEnquirysourceData(enquirysourceData)
    }

    const fetchEmployeeData = async () => {
      const employeeData = await getEmployeeDropdown('')
      setEmployeeData(employeeData)
      setEmployeeDataOrig(employeeData)
    }

    fetchEmployeeData()
    fetchSiteData()
    fetchClientData()
    fetchEnquirysourceData()
  }, [])

  useEffect(() => {
    const fetchSiteData = async () => {
      const siteData = await getSitesDropdown('')
      setSiteData(siteData)
      setSiteDataOrig(siteData)
    }

    fetchSiteData()
  }, [props.siteData])

  // Handle initial values from props (e.g., when coming from /enquiries/:contactNumber)
  useEffect(() => {
    if (props.initialValues) {
      setFormState(props.initialValues);
      
      // If client is pre-filled, fetch addresses and contacts for that client
      if (props.initialValues.clientName?.value) {
        getAndStoreAddressesForCustomer(props.initialValues.clientName.value);
        getAndStoreContactsForCustomer(props.initialValues.clientName.value);
        
        // Check if client is bad debter
        getClientByIdV2(props.initialValues.clientName.value).then((client) => {
          setIsBadDebter(client.badDebter || false);
        }).catch(() => {
          setIsBadDebter(false);
        });
      }
    }
  }, [props.initialValues]);

  const handleCheckSiteExists = () => {
    const clientId = formState.client.value

    if (matchSiteActive === true) {
      getMatchingClientSite(clientId).then((result) => {
        if (result !== null && result !== undefined) {
          const matchingId = (result as any).key

          // const newSiteData = siteData.filter((item) => Number(item.value) === matchingId)

          const fetchNewSiteData = async (id: number) => {
            await getTargetSite(id).then((result: any) => {
              const newSite = [{
                value: result.siteId,
                text: result.siteAddr,
              }]

              setSiteData(newSite)
            })
          }

          fetchNewSiteData(matchingId)

          showToast('Site matched', 'success')
        } else {
          showToast('No matching site, try searching manually', 'error')
        }
      })
    } else {
      showToast('Select a client', 'error')
    }
  }

  //Handle submit
  // Remove duplicate handleSubmit

  //Search filters
  const searchSiteDropdown = (searchTerm: string) => {
    const fetchSiteData = async (search: string) => {
      await getSitesDropdown(search).then((result) => {
        setSiteData(result)
      })
    }

    fetchSiteData(searchTerm)
  }

  const searchClientDropdown = (searchTerm: string) => {
    const fetchClientData = async (search: string) => {
      await getClientsDropdown(search).then((result) => {
        setClientData(result)
      })
    }

    fetchClientData(searchTerm)
  }

  const searchEmployeeDropdown = (searchTerm: string) => {
    const fetchEmployeeData = async (search: string) => {
      await getEmployeeDropdown(search).then((result) => {
        setEmployeeData(result)
      })
    }

    fetchEmployeeData(searchTerm)
  }

  const handleAddSite = () => {
    props.onAddSiteToggle()
  }

  const handleAddClient = () => {
    props.onAddClientToggle()
  }

  const handleFreehand = () => {
    setFreehand(!freehand)
  }

  const getAndStoreAddressesForCustomer = async (customerId: number) => {
    try {
      if (customerId) {
        const res = await getAddressesForClientDropdown(customerId);
        setSiteData(res);
        setFormState((prev: any) => ({
          ...prev,
          siteAddr: {
            text: res.length === 1 ? res[0]?.text || 0 : '',
            value: res.length === 1 ? res[0]?.value || 0 : 0,
          }
        }))
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (formState.clientName.value !== 0) {
      getAndStoreAddressesForCustomer(formState.clientName.value);
    }
  }, [formState.clientName])


  // Contacts for client
  const [contactsForClient, setContactsForClient] = useState<dropDown[]>([]);

  const getAndStoreContactsForCustomer = async (customerId: number) => {
    try {
      const res = await getClientsForClientsDropdown(customerId);
      setContactsForClient(res);
      setFormState((prev: any) => ({
        ...prev,
        contactId: res.length === 1 ? res[0]?.value || 0 : 0,
      }))

    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (formState.clientName.value !== 0) {
      getAndStoreContactsForCustomer(formState.clientName.value);
    }
  }, [formState.clientName]);


  const clearAccountFields = () => {
    setFormState((prev: any) => ({
      ...prev,
      clientName: '',
      siteAddr: {
        text: '',
        value: 0,
      },
      contactId: 0,
    }))
  }
  

  const handleSubmit = (event: any, resetForm?: () => void) => {
    if (!formState.enquirysourceId || !formState.enquirysourceId.value || formState.enquirysourceId.value === 0) {
      if (event && event.preventDefault) event.preventDefault();
      showToast('Please select an enquiry source before saving.', 'error');
      return;
    }
    console.log('AddEnquiryForm handleSubmit - formState.dueDate:', formState.dueDate);
    const dataToSubmit = {
      ...formState,
      dueDate: formState.dueDate || null
    };
    console.log('AddEnquiryForm handleSubmit - dataToSubmit:', dataToSubmit);
    props.onEnquirySubmit(dataToSubmit);
    if (typeof resetForm === 'function') resetForm();
  };

  return (
    <Form
      onSubmit={() => {}}
      render={(formRenderProps) => (
        <FormElement style={{ padding: '2rem', marginBottom: '5rem' }}>
          <fieldset className={'k-form-fieldset'}>
            <div className='form__subtitle'>
              Add enquiry details:
              <span style={{ display: 'inline-flex', gap: '0.5rem' }}>
                <button
                  type='button'
                  className='form__reset__button'
                  onClick={() => props.onShowRates?.()}
                  title='The current schedules of rates, read only'
                >
                  <FaTable style={{ marginRight: '0.35rem', verticalAlign: '-1px' }} />
                  Schedules of rates
                </button>
                <button
                  className='form__reset__button'
                  onClick={() => {formRenderProps.onFormReset(); clearAccountFields()}}
                >
                  Clear fields
                </button>
              </span>
            </div>

            <Field
              disabled={props.lockEdit}
              data={clientData}
              originalData={clientDataOrig}
              name={'clientName'}
              component={FormDropDownListFilter}
              label={'Choose a client:'}
              setData={setClientData}
              searchDropdown={searchClientDropdown}
              defaultItem={formState.clientName}
              onChange={(e) => {
                setFormState({
                  ...formState,
                  clientName: {
                    ...e.value,
                    value: parseInt(e.value.value, 10),
                  },
                });
                // Check if client is bad debter
                const clientId = parseInt(e.value.value, 10);
                if (clientId > 0) {
                  getClientByIdV2(clientId).then((client) => {
                    setIsBadDebter(client.badDebter || false);
                  }).catch(() => {
                    setIsBadDebter(false);
                  });
                } else {
                  setIsBadDebter(false);
                }
                // formRenderProps.onChange("contact", { value: 0 });
                // formRenderProps.onChange("address", { value: 0 });

              }}
              hasButton={props.lockEdit ? false : true}
              buttonText={'Add Account'}
              buttonAction={() => {
                props.setAddAccountVisible(true)
                props.setAccountMode("add");
                props.setAccountInitialTab(0);
              }}
            />

            <Field
              disabled={props.lockEdit}
              data={contactsForClient}
              originalData={siteDataOrig}
              name={'contact'}
              component={FormDropDownListFilter}
              label={'Contact:'}
              setData={setContactsForClient}
              onOpen={() => getAndStoreContactsForCustomer(formState.clientName.value)}
              searchDropdown={searchSiteDropdown}
              defaultItem={contactsForClient.find(item => Number(item.value) === Number(formState.contactId))}
              onChange={(e) => {
                setFormState({
                  ...formState,
                  contactId: parseInt(e.value.value, 10),
                })
              }}
              hasButton={props.lockEdit ? false : formState.clientName.value > 0}
              buttonText={'Add Contact'}
              buttonAction={() => {
                props.setAccountMode("edit");
                props.setSelectedAccountId(formState.clientName.value);
                props.setAccountInitialTab(2);
                props.setAddAccountVisible(true)
              }}
            />

            <Field
              disabled={props.lockEdit}
              data={siteData}
              originalData={siteDataOrig}
              name={'address'}
              component={FormDropDownList}
              label={'Address:'}
              setData={setSiteData}
              onOpen={() => getAndStoreAddressesForCustomer(formState.clientName.value)}
              searchDropdown={searchSiteDropdown}
              defaultItem={siteData.find(item => Number(item.value) === Number(formState.siteAddr.value))}
              onChange={(e) => {
                setFormState({
                  ...formState,
                  siteAddr: {
                    ...e.value,
                    value: parseInt(e.value.value, 10),
                  },
                })
              }}
              hasButton={props.lockEdit ? false : formState.clientName.value > 0}
              buttonText={'Add Address'}
              buttonAction={() => {
                props.setAccountMode("edit");
                props.setSelectedAccountId(formState.clientName.value);
                props.setAccountInitialTab(1);
                props.setAddAccountVisible(true)
              }}
            />

            {/* {freehand ? (
              <Field
                name={'clientName'}
                component={FormInput}
                label={'Client:'}
                placeholder={'Enter client name:'}
                hasButton={true}
                buttonText={'Choose from list'}
                buttonAction={handleFreehand}
                onChange={(e: any) => {
                  setFormState({ ...formState, clientName: e.value })
                }}
              />
            ) : (
              <Field
                data={clientData}
                originalData={clientDataOrig}
                name={'client'}
                component={FormDropDownListFilter}
                label={'Client:'}
                setData={setClientData}
                searchDropdown={searchClientDropdown}
                placeholder={'Choose a client:'}
                hasButton={true}
                buttonText={'Freehand Entry'}
                buttonAction={handleFreehand}
                hasSecondButton={true}
                secondButtonText={'Add Client'}
                secondButtonAction={handleAddClient}
                onChange={(e: any) => {
                  setFormState({
                    ...formState,
                    client: { ...e.value, value: parseInt(e.value.value, 10) },
                  })
                  setMatchSiteActive(true)
                }}
              />
            )} */}

            {/* <Field
              data={siteData}
              originalData={siteDataOrig}
              name={'siteAddr'}
              component={FormDropDownListFilter}
              defaultValue={formState.siteAddr}
              label={'Site Address:'}
              setData={setSiteData}
              searchDropdown={searchSiteDropdown}
              validator={requiredValidator}
              hasButton={true}
              buttonText={'Add Site'}
              buttonAction={handleAddSite}
              hasSecondButton={true}
              secondButtonText={'Match site'}
              secondButtonAction={handleCheckSiteExists}
              onChange={(e: any) => {
                setFormState({
                  ...formState,
                  siteAddr: { ...e.value, value: parseInt(e.value.value, 10) },
                })
              }}
            /> */}

            <Field
              data={enquirysourceData}
              name={'enquirysourceId'}
              component={FormDropDownList}
              label={'Enquiry source: *'}
              placeholder={'Choose enquiry source:'}
              required={true}
              validator={requiredValidator}
              onChange={(e: any) => {
                setFormState({
                  ...formState,
                  enquirysourceId: {
                    ...e.value,
                    value: parseInt(e.value.value, 10),
                  },
                })
              }}
            />

            <Field
              name={'dueDate'}
              component={FormDatePicker}
              label={'Due Date:'}
              required={true}
              validator={requiredValidator}
              onChange={(e: any) => {
                setFormState({ ...formState, dueDate: e.value })
              }}
            />

            <Field
              name={'description'}
              component={FormTextArea}
              label={'Description:'}
              placeholder={'Enter a description:'}
              validator={requiredValidator}
              onChange={(e: any) => {
                setFormState({ ...formState, description: e.value })
              }}
            />

            {isBadDebter && (
              <div style={{
                backgroundColor: '#fff3cd',
                border: '1px solid #ffc107',
                borderRadius: '4px',
                padding: '12px 16px',
                marginTop: '8px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                color: '#856404'
              }}>
                <FaFlag style={{ fontSize: '18px', color: '#ffc107' }} />
                <span style={{ fontWeight: '600' }}>Contact accounts department</span>
              </div>
            )}

            <Field
              data={employeeData}
              originalData={employeeDataOrig}
              name={'employeeAssignedToId'}
              component={FormDropDownListFilter}
              label={'Assigned employee:'}
              setData={setEmployeeData}
              placeholder={'Choose a employee to assign:'}
              searchDropdown={searchEmployeeDropdown}
              validator={requiredValidator}
              onChange={(e: any) => {
                setFormState({
                  ...formState,
                  employeeAssignedToId: {
                    ...e.value,
                    value: parseInt(e.value.value, 10),
                  },
                })
              }}
            />

          </fieldset>
          <div className='button__container'>
            {props.lockEdit === false && (
              <button
                onClick={(e) => {
                  handleSubmit(e, formRenderProps.onFormReset);
                }}
                disabled={!formRenderProps.allowSubmit || (formState.clientName.value === 0 || formState.siteAddr.value === 0 || formState.contactId === 0 || formState.description === '' || formState.employeeAssignedToId.value === 0)}
                style={{
                  width: '100%',
                  marginTop: '0.5rem',
                  height: '3rem',
                  backgroundColor: 'rgb(174 199 65)',
                  color: 'rgb(71 83 21)',
                  border: 0,
                  borderRadius: '0.3rem',
                }}
              >
                Add enquiry
              </button>
            )}
          </div>
        </FormElement>
      )}
    />
  )
}

export default AddEnquiryForm
